<app-entity-page
  [closeClicked]="closeClicked"
  [detailsContentTitle]="((coinDetails?.coinTitle || '') | translateLang | async) ?? ''"
  [loading]="coinLoading">
  <ng-template #detailsContent>
    <div class="coin-page" *ngIf="currentLanguage$ | async as lang">

      <div *ngIf="!coinLoading && coinDetails" class="coin-content" [ngClass]="{ 'en': lang === 'en' }">

        <span class="menora-badge" [ngClass]="coinDetails.inMenora ? 'in' : 'out'">
          {{ coinDetails.inMenora
              ? (lang === 'en' ? 'In Menora' : 'קיים במנורה')
              : (lang === 'en' ? 'Not in Menora' : 'לא קיים במנורה') }}
        </span>

        <img *ngIf="coinDetails.imageUrl" class="coin-image"
             [src]="coinDetails.imageUrl"
             [alt]="lang === 'en' ? coinDetails.coinTitle.english : coinDetails.coinTitle.hebrew" />

        <table class="coin-rows">
          <tr *ngFor="let row of rows">
            <th>{{ row.label | translate }}</th>
            <td>{{ row.value }}</td>
          </tr>
        </table>

      </div>

    </div>
  </ng-template>
</app-entity-page>
